import type { DataSource } from './DataSource'
import type { Realtime } from '../realtime/Realtime'
import { MockDataSource } from './mock/MockDataSource'
import { MockRealtime } from './mock/MockRealtime'
import { RealDataSource } from './RealDataSource'
import { env } from '../config/env'
import { FirebaseRealtime } from './firebase/FirebaseRealtime'
import { PusherRealtime } from './pusher/PusherRealtime'
import { CompositeRealtime } from './realtime/CompositeRealtime'

export interface Backend { dataSource: DataSource; realtime: Realtime }

const NULL_REALTIME: Realtime = {
  start() {}, stop() {}, on() { return () => {} }, presenceOf() { return 'offline' },
}

// Factory: escolhe o backend por env (env.dataSource). Mock é o default offline;
// `real` consome a API (precisa de backend + token). Pusher real entra no M6.
export function createBackend(): Backend {
  if (env.dataSource === 'real') {
    const delegates: Realtime[] = []
    if (env.firebaseUrl) {delegates.push(new FirebaseRealtime(env.firebaseUrl))}
    if (env.pusherKey) {delegates.push(new PusherRealtime(env.pusherKey, env.pusherCluster))}
    const realtime = delegates.length === 0 ? NULL_REALTIME : delegates.length === 1 ? delegates[0] : new CompositeRealtime(delegates)
    return { dataSource: new RealDataSource(), realtime }
  }
  const dataSource = new MockDataSource()
  return { dataSource, realtime: new MockRealtime(dataSource) }
}
